import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function() {

  (function seminarFinderTeaser() {

    const modules = document.querySelectorAll(".hkbis-seminar-finder-teaser");

    if (modules && modules.length > 0) {

      [...modules].forEach(module => {

        const imageParts = module.querySelectorAll(".hkbis-seminar-finder-teaser__image-window");

        if (imageParts ) {

          const startPostitionsY = [
            -110,
            60,
            -90,
            70,
            -70,
            50,
            -50,
            100,
            -100,
            55,
          ];

          [...imageParts].forEach((part, partIndex) => {
            gsap.set(part, {y: startPostitionsY[partIndex]});
          });

          const animateImageParts = () => {
            [...imageParts].forEach((part, partIndex) => {
              gsap.to(part, {y: 0, duration: 3, ease: 'power1'});
            });
          };

          let timeline = gsap.timeline({
            scrollTrigger: {
              trigger: module,
              start: 'top center',
              onEnter: animateImageParts,
              once: true,
            },
          });
        }
      })
    }
  })();
});
